// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var SelectorOverrides$SmartcutsMacros = require("../../commands/shared/SelectorOverrides.bs.js");
var ExtensionMessaging$SmartcutsMacros = require("../../ExtensionMessaging.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../ExtensionMessaging__FromExtension.bs.js");

var rejectToExtension_encode = ExtensionMessaging$SmartcutsMacros.rejectToBg_encode;

var rejectToExtension_decode = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode;

function basicEvent_encode(v) {
  if (v.TAG === /* MessageFromExtension */0) {
    return [
            "MessageFromExtension",
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v._0),
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1),
            ExtensionMessaging$SmartcutsMacros.rejectToBg_encode(v._2)
          ];
  } else {
    return [
            "DidGetNewAuthToken",
            Decco.stringToJson(v._0)
          ];
  }
}

function basicEvent_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidGetNewAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidGetNewAuthToken */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "MessageFromExtension" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* MessageFromExtension */0,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e$1 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function otherFailureReason_encode(v) {
  if (typeof v === "number") {
    return ["UnhandledException"];
  }
  switch (v.TAG | 0) {
    case /* InvalidUrl */0 :
        return [
                "InvalidUrl",
                Decco.stringToJson(v._0)
              ];
    case /* InvalidArgument */1 :
        return [
                "InvalidArgument",
                Decco.stringToJson(v._0)
              ];
    case /* FailWithElementNotFound */2 :
        return [
                "FailWithElementNotFound",
                Decco.stringToJson(v._0),
                Selector$SmartcutsMacros.selector_encode(v._1)
              ];
    case /* FailWithElementNotFound2 */3 :
        return [
                "FailWithElementNotFound2",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
              ];
    case /* FailWithErrorWhileSearchForElement */4 :
        return [
                "FailWithErrorWhileSearchForElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
              ];
    
  }
}

function otherFailureReason_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FailWithElementNotFound" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithElementNotFound */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "FailWithElementNotFound2" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithElementNotFound2 */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "FailWithErrorWhileSearchForElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithErrorWhileSearchForElement */4,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$4 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "InvalidArgument" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InvalidArgument */1,
                      _0: v0._0
                    }
                  };
          }
          var e$6 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "InvalidUrl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InvalidUrl */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$7 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "UnhandledException" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnhandledException */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyOtherFailureReason(reason) {
  if (typeof reason === "number") {
    return "UnhandledException";
  }
  switch (reason.TAG | 0) {
    case /* InvalidUrl */0 :
        return "InvalidUrl(" + (StringUtils$SmartcutsMacros.quote(reason._0) + ")");
    case /* InvalidArgument */1 :
        return "InvalidArgument(" + (reason._0 + ")");
    case /* FailWithElementNotFound */2 :
        return "FailWithElementNotFound(" + (reason._0 + ", selector)");
    case /* FailWithElementNotFound2 */3 :
        return "FailWithElementNotFound2(" + (reason._0 + ", locator)");
    case /* FailWithErrorWhileSearchForElement */4 :
        return "FailWithErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + (reason._1 + ")"));
    
  }
}

exports.rejectToExtension_encode = rejectToExtension_encode;
exports.rejectToExtension_decode = rejectToExtension_decode;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.otherFailureReason_encode = otherFailureReason_encode;
exports.otherFailureReason_decode = otherFailureReason_decode;
exports.stringifyOtherFailureReason = stringifyOtherFailureReason;
/* Selector-SmartcutsMacros Not a pure module */
